// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gamaification-container {
  margin-top: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/gamification/gamification-result/gamification-result.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF","sourcesContent":[".gamaification-container {\n  margin-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
